import { render, staticRenderFns } from "./PaginaAdminPuestos.vue?vue&type=template&id=fdf3ecd0"
import script from "./PaginaAdminPuestos.vue?vue&type=script&lang=js"
export * from "./PaginaAdminPuestos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports